import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Intercom } from 'ng-intercom';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class IntercomControlService {
  constructor(private readonly intercom: Intercom) {}

  public openIntercomWithMessage(message: string) {
    if (!message || message.length === 0) {
      this.intercom.show();
    } else {
      this.intercom.showNewMessage(message);
    }
  }

  public closeIntercom() {
    this.intercom.shutdown();
  }
}
